import { GraphQLClient } from 'graphql-request'

const clientRace = new GraphQLClient(process.env.REACT_APP_RACE_API, { headers: { 'x-thairun-client-id': 'bot-messenger' } })

const clientResults = new GraphQLClient(process.env.REACT_APP_GRAPHQL_URI)

export {
  clientRace,
  clientResults,
}



// WEBPACK FOOTER //
// ./src/CreateEcer/client.js